<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Group Sharing</b>
        <b-button
          v-show="hasGroups"
          v-if="isOrgAdmin && hasMoreGroupsToShareWith"
          disabled
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
        >
          <span class="button-text">Share with</span>
        </b-button>
      </b-card-header>

      <!-- List groups -->
      <div v-if="shareNoteRecords.length > 0">
        <b-list-group v-for="sp in shareNoteRecords" :key="sp.id" flush>
          <b-list-group-item>
            <a href="" @click.prevent="toggleUpdateShareNoteModal(sp.id)">
              {{ _.get(sp, 'sgroup.groupName', 'Unknown') }} <img :src="'/static/img/' + (sp.noteShareStatus ? 'shareYes.png' : 'shareNo.png')" height="21" width="21">
            </a>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="shareNoteRecords.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>{{ !hasGroups ? 'Your organization does not belong to any groups' : 'This record is not currently shared' }}</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <!-- View/Update Existing -->
    <UpdateShareNoteModal
      :noteId="noteId"
      :noteOrganizationOwner="noteOrganizationOwner"
      :shareRecord="shareRecord"
      :groupId="selectedGroup"
    ></UpdateShareNoteModal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateShareNoteModal from '@/components/Share/UpdateShareNoteModal'

export default {
  name: 'share-note-list',
  props: {
    noteId: Number,
    noteOrganizationOwner: Number,
    personId: Number
  },
  components: {
    UpdateShareNoteModal
  },
  data: function () {
    return {
      showUpdateNoteModal: false,
      selectedGroup: {},
      shareRecordId: 0
    }
  },
  computed: {
    ...mapGetters({
      shareNoteRecords: 'shareNoteRecords',
      // userShareAllowedGroups: 'userShareAllowedGroups',
      getGroupsByOrg: 'getGroupsByOrg',
      userTransferAllowed: 'userTransferAllowed',
      userCurrentContext: 'userCurrentContext' // Passing user context to determine if they have isOrgAdmin
    }),
    hasGroups: function () {
      let groups = this.getGroupsByOrg
      return groups.length > 0
    },
    hasMoreGroupsToShareWith: function () {
      let condition = false
      let countGroups = this.getGroupsByOrg.length || 0
      let countShareRecords = this.shareNoteRecords.length || 0
      if (countGroups > countShareRecords) {
        condition = true
      }
      return condition
    },
    isOrgAdmin: function () {
      return this.userTransferAllowed(this.noteOrganizationOwner)
    },
    shareRecord: function () {
      return this.shareNoteRecords.find((r) => r.id === this.shareRecordId)
    }
  },
  watch: {
    noteId: function (newValue) {
      if (newValue && _.isInteger(newValue)) {
        this.$store.dispatch('getShareNoteRecords', {
          snote: newValue,
          populate: 'sgroup,snote'
        // populate: 'sgroup,snote,updatedBy,createdBy'
        })
      }
    }
  },
  methods: {
    toggleUpdateShareNoteModal: function (shareRecordId) {
      this.shareRecordId = shareRecordId
      this.$bvModal.show('update-share-note') // this.showUpdateNoteModal = !this.showUpdateNoteModal
    },
    resetAll: function () {
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'shareNoteResponse' })
      this.$store.commit('RESET_SHARE_NOTE_RECORDS')
    }
  },
  beforeDestroy () {
    this.resetAll()
  },
  created () {
    if (this.noteId && _.isInteger(this.noteId)) {
      this.$store.dispatch('getShareNoteRecords', {
        snote: this.noteId,
        populate: 'sgroup,snote'
        // populate: 'sgroup,snote,updatedBy,createdBy'
      })
      this.$store.dispatch('getGroupsByOrg', { id: this.noteOrganizationOwner })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Note/ShareNoteList.vue